module.exports = __webpack_public_path__ + "static/media/score-background.1a536ab3.svg";